import React from 'react';
import PropTypes from 'prop-types';
import AccountsTable from '../../shared/widgets/containers/AccountsTable';
import history from '../../../history';

/**
 * AccountsList component
 * @name AccountsList
 */
const AccountsList = ({containerID}) => <AccountsTable containerID={containerID}
                                                       onRowClick={account => history.push(`/accounts/${account.containerID}`)}
                                                       rowsPerPage={10}/>;

export default AccountsList;

AccountsList.propTypes = {
  /**
   * The container ID
   */
  containerID: PropTypes.number.isRequired,
};
